module.exports = __webpack_public_path__ + "img/delta-to-delta-aux-trafo.4cf6cb0a.svg";